import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import LinearProgress from '@material-ui/core/LinearProgress';
import FlameIcon from '@material-ui/icons/Whatshot';

import { translate } from 'services/i18nService';
import TippingStore from 'stores/TippingStore';

import styles from './PerformerGoal.css';


function PerformerGoal() {
  const getPercentageOfTotal = (total, part = 0) => {
    const percent = (part / total) * 100;
    if (percent > 100) {
      return 100;
    }

    return percent;
  };

  const { tippingInfo: { goal, goalbalance, message } } = TippingStore;

  const tokensTipped = goalbalance ? parseInt(goalbalance, 10) : 0;
  const tokenGoal = goal ? parseInt(goal, 10) : 0;
  const statusMessage = message && decodeURIComponent(message);

  const percentageComplete = getPercentageOfTotal(tokenGoal, tokensTipped) || 0;
  const percentageLeft = 100 - percentageComplete;
  const hasTokenGoal = tokenGoal !== 0;
  const goalExceeded = tokensTipped >= tokenGoal;
  const goalAlmostReached = percentageLeft <= 10 && percentageLeft > 0;

  const maskClasses = classNames({
    [styles.blink]: true,
    [styles.mask]: true,
  });
  const goalTextClasses = classNames({
    [styles.blink]: goalAlmostReached,
    [styles.progressInfo]: true,
  });
  const flameClasses = classNames({
    [styles.blink]: goalAlmostReached || goalExceeded,
    [styles.icon]: true,
  });

  return (
    <div className={styles.goalWrap}>
      {hasTokenGoal && (
        <div className={styles.performerGoal}>
          <div className={styles.progressBar}>
            <LinearProgress
              classes={{
                root: styles.goalProgress,
                barColorPrimary: styles.barColorPrimary,
                colorPrimary: styles.barColorPrimary,
                bar1Determinate: styles.bar1Determinate,
              }}
              value={percentageComplete}
              variant="determinate"
            />
            {goalExceeded && <span className={maskClasses} />}
            <span className={goalTextClasses}>
              {translate('profile.v2.goal')}: {tokensTipped} &#47; {tokenGoal}
            </span>
          </div>
          <div className={styles.goalDescription}>
            <FlameIcon className={flameClasses} />
            <p>{statusMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default observer(PerformerGoal);
